
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../controlador';
    import a_barra from './cursos-barra.vue';
    import a_menu from './cursos-menu.vue';

    import buscador_crear from './crear/cursos-crear-buscador.vue';
    import crear from './crear/cursos-crear.vue';

    import buscador_detalles from './detalles/cursos-detalles-buscador.vue';
    import detalles from './detalles/cursos-detalles.vue';

    import buscador_lista from './listado/cursos-lista-buscador.vue';
    import lista from './listado/cursos-lista.vue';
    import filtros from './listado/cursos-filtros.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            a_menu,
            a_barra,

            buscador_lista,
            lista,
            filtros,

            buscador_crear,
            crear,

            buscador_detalles,
            detalles,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public MenuAbierto: boolean = true;
        public Buscador: string = '';
        public Estado: string = '';
        public SubModo: string = '';
        public Modo: string = '';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Buscador = this.Controlador.Vista.Buscador;
            this.Estado = this.Controlador.Vista.Estado;
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onBuscador.subscribe( () => this.Buscador = this.Controlador.Vista.Buscador ) );
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( () => this.Estado = this.Controlador.Vista.Estado ) );
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () =>
            {
                this.Modo = this.Controlador.Vista.Modo;
                this.Refrescar();
                console.log( this.Modo );
            } ) );
            this.Eventos.push( this.Controlador.Vista.onSubModo.subscribe( () => this.SubModo = this.Controlador.Vista.SubModo ) );
            this.Eventos.push( this.Controlador.Vista.onMenuAbierto.subscribe( () => this.MenuAbierto = this.Controlador.Vista.MenuAbierto ) );

        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
